import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useCollection } from "react-firebase-hooks/firestore";
import { collection } from "firebase/firestore";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Firestore } from "../firebase/firebase";
import { Grid, Table, Input, Segment, Menu } from "semantic-ui-react";
import User from "./user";
import Loading from "../app/loading";
import Paginator from "../templates/utils/pagination";

const Users = () => {
  const { page } = useParams();
  const [pageBy, setPageBy] = useState(10);
  const [users, setUsers] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState(null);
  const [userSearch, setUserSearch] = useState("");
  const [column, setColumn] = useState();
  const [direction, setDirection] = useState(null);
  const [startEnd, setStartEnd] = useState({ start: 0, end: pageBy });

  const query = collection(Firestore, "users");

  const [value, loading, error] = useCollection(query, {
    snapshotListenOptions: { includeMetadataChanges: true },
  });

  const handleSort = (clickedColumn) => {
    if (column !== clickedColumn) {
      setColumn(clickedColumn);
      setDirection("ascending");
      setUsers(_.sortBy(users, [clickedColumn]));
      return;
    }
    setDirection(direction === "ascending" ? "descending" : "ascending");
    setUsers(users.reverse());
  };

  const handleSearch = (e, { value }) => setUserSearch(value);

  useEffect(() => {
    if (value) {
      const arr = value.docs.map((doc) => {
        let data = doc.data();
        return { id: doc.id, ...data };
      });
      setUsers(arr);
      setFilteredUsers(arr);
    }
  }, [value]);

  useEffect(() => {
    let filteredArray = [];
    if (userSearch && filteredUsers) {
      filteredArray = filteredUsers.filter((user) => {
        if (user.displayName)
          return user.displayName
            .toLocaleLowerCase()
            .includes(userSearch.toLocaleLowerCase());
      });
      setUsers(filteredArray);
    }
    if (!userSearch && filteredUsers) setUsers(filteredUsers);
  }, [filteredUsers, userSearch]);

  useEffect(() => {
    let start = (parseInt(page) - 1) * pageBy;
    const end = start + pageBy;
    if (users) {
      if (page * pageBy - pageBy > users.length) {
        start = 0;
      }
    }
    setStartEnd({ start, end });
  }, [page, users, pageBy]);

  if (!users || loading || error) return <Loading />;

  return (
    <Grid padded>
      <Grid.Column computer={16} tablet={16} mobile={16}>
        <Menu attached="top" borderless>
          <Menu.Item header>Users</Menu.Item>
          <Menu.Item>
            <Input
              icon="search"
              placeholder="Search by name"
              type="text"
              onChange={handleSearch}
              value={userSearch}
            />
          </Menu.Item>
        </Menu>
        <Segment attached="bottom" className="users-table">
          <Table celled padded sortable unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  sorted={column === "displayName" ? direction : null}
                  onClick={() => handleSort("displayName")}
                >
                  Name
                </Table.HeaderCell>
                <Table.HeaderCell
                  sorted={column === "email" ? direction : null}
                  onClick={() => handleSort("email")}
                >
                  Email
                </Table.HeaderCell>
                <Table.HeaderCell
                  sorted={column === "organisation" ? direction : null}
                  onClick={() => handleSort("organisation")}
                >
                  Organisation
                </Table.HeaderCell>
                <Table.HeaderCell>Viewer</Table.HeaderCell>
                <Table.HeaderCell>Editor</Table.HeaderCell>
                <Table.HeaderCell>Ad Ops</Table.HeaderCell>
                <Table.HeaderCell>Administrator</Table.HeaderCell>
                <Table.HeaderCell>
                  Restrict by
                  <br /> retailer
                </Table.HeaderCell>
                <Table.HeaderCell>Retailer</Table.HeaderCell>
                <Table.HeaderCell>
                  Restrict by
                  <br /> advertiser
                </Table.HeaderCell>
                <Table.HeaderCell>Advertiser</Table.HeaderCell>
                <Table.HeaderCell>Edit</Table.HeaderCell>
                <Table.HeaderCell>Delete</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <TransitionGroup component="tbody">
              {users.slice(startEnd.start, startEnd.end).map((item, index) => (
                <CSSTransition timeout={500} key={item.id} classNames="item">
                  <User user={item} />
                </CSSTransition>
              ))}
            </TransitionGroup>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="13">
                  <Paginator
                    pageBy={pageBy}
                    setPageBy={setPageBy}
                    total={users.length}
                    page={page}
                    path={"/admin/users/"}
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default Users;
